import {toast} from "react-toastify"

export const successToast = (msg: string, handler?: any) => {
  toast.success(msg, {
    style: {background: "#2E7D32"},
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    onOpen: handler !== undefined ? () => {
      handler();
    } : () => {
      return undefined
    },
    pauseOnHover: true,
    draggable: true,
    progress: 0,
    theme: "colored",
  });
}
export const warningToast = (msg: string) => {
  toast.warning(msg, {
    style: {background: "#FFCC00"},
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: 0,
    theme: "colored",
  });
}
export const errorToast = (msg: string | React.ReactNode, autoClose: number = 3000) => {
  toast.error(msg, {
    style: {background: "#D50000", overflowWrap: "anywhere"},
    position: "top-right",
    autoClose: autoClose,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: 0,
    theme: "colored",
  });
}